export default [
  {
    // portalGroup: 'all.public',
    path: '/404',
    name: '404',
    component: () => import('./404.vue')
  },
  {
    // portalGroup: 'all.public',
    path: '/portalError',
    name: 'portalError',
    meta: { debug: true },
    component: () => import('./PortalError.vue')
  }
]
